var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9439 27.3027L39.3348 36.655C39.6983 37.017 39.6983 37.6025 39.3348 37.9646L37.5865 39.7056C37.223 40.0677 36.6351 40.0677 36.2715 39.7056L26.8807 30.3534C26.7105 30.1762 26.6099 29.9451 26.6099 29.6985V28.6817C23.7865 31.1083 20.1122 32.5797 16.0897 32.5797C7.2017 32.5797 0 25.4076 0 16.5561C0 7.70454 7.2017 0.53241 16.0897 0.53241C24.9778 0.53241 32.1795 7.70454 32.1795 16.5561C32.1795 20.562 30.702 24.2212 28.2653 27.0331H29.2864C29.5339 27.0331 29.766 27.1255 29.9439 27.3027ZM3.71143 16.5561C3.71143 23.3661 9.25 28.882 16.0881 28.882C22.9262 28.882 28.4648 23.3661 28.4648 16.5561C28.4648 9.74601 22.9262 4.23018 16.0881 4.23018C9.25 4.23018 3.71143 9.74601 3.71143 16.5561Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9f095249.svg";
export { ForwardRef as ReactComponent };